module.exports = __webpack_public_path__ + "static/ud_on_the_office-1e99af27f66dfc151c53384839c12f74.svg";